export const EXECUTION_STATE_INPROGRESS = 'INPROGRESS';
export const EXECUTION_STATE_STARTED = 'STARTED';
export const EXECUTION_STATE_SUBMITTED = 'SUBMITTED';

export const EXECUTION_STATE_COMPLETED = 'COMPLETED';
export const EXECUTION_STATE_FAILED = 'FAILED';
